exports.install = function (Vue, options) {
	Vue.prototype.api.Statistics = {
		getList(value={})//获取基地列表
		{
			if(value.tokenTJ==null)
			{
				value.tokenTJ=Vue.prototype.getCookie(Vue.prototype.config.tokenTJ);
			}
			return Vue.prototype.axiosget("/api/tj/Statistics/getList",value)
			.then((response)=>{
				return response;
			});
		},
		devicesData(value={})//设备传感器数据统计
		{
			return Vue.prototype.axiosget("/api/tj/Statistics/devicesData",value)
			.then((response)=>{
				return response;
			});
		},
		onLineDevices(value={})//在线设备统计
		{
			return Vue.prototype.axiosget("/api/tj/Statistics/onLineDevices",value)
			.then((response)=>{
				return response;
			});
		},
		terminalDevicesVideo(value={})//终端，传感器，摄像头统计
		{
			return Vue.prototype.axiosget("/api/tj/Statistics/terminalDevicesVideo",value)
			.then((response)=>{
				return response;
			});
		},
		LatestData(value={})//最新传感器数据
		{
			return Vue.prototype.axiosget("/api/tj/Statistics/LatestData",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
